import { render, staticRenderFns } from "./TheDashboard.vue?vue&type=template&id=d4437a9c&"
import script from "./TheDashboard.vue?vue&type=script&lang=js&"
export * from "./TheDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports